"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var SvgReplyAll = function (props) { return (React.createElement("svg", __assign({ "data-testid": "ICON_REPLY-ALL", width: "1em", height: "1em", viewBox: "0 0 17 16" }, props),
    React.createElement("path", { d: "M6.707 1.293a1 1 0 0 1 0 1.414L2.414 7l4.293 4.293a1 1 0 1 1-1.414 1.414l-5-5a1 1 0 0 1 0-1.414l5-5a1 1 0 0 1 1.414 0Z" }),
    React.createElement("path", { d: "M7.914 6H10c1.608 0 2.851.52 3.772 1.352.9.812 1.428 1.864 1.742 2.842.316.981.434 1.945.476 2.653a11.643 11.643 0 0 1 .01 1.192l-.002.02v.011L15 14l.998.07a1 1 0 0 1-1.995-.14V13.921a1.328 1.328 0 0 0 .002-.045 9.736 9.736 0 0 0-.011-.91 8.946 8.946 0 0 0-.383-2.16c-.249-.772-.627-1.47-1.18-1.97C11.9 8.355 11.141 8 10 8H7.914l3.293 3.293a1 1 0 0 1-1.414 1.414l-5-5a1 1 0 0 1 0-1.414l5-5a1 1 0 0 1 1.414 1.414L7.914 6Z" }))); };
exports.default = SvgReplyAll;
